@if (!loading){
<ng-container *transloco="let t; prefix: 'feedback'">

  @if (feedbackPending === true && feedbackQuestions.length > 0) {
  <div class="container flex flex-col justify-center text-center max-w-[800px]">
    <div class="py-12" [formGroup]="userForm">
      <div class="mb-[72px] mt-12">
        <div class="mb-[72px] mt-12">
          <h1 class="text-[40px] font-bold text-black">{{t('user.header')}}</h1>
          <p class="text-gray-900 ">{{t('user.address')}} {{propertyAddress || '-'}}</p>
        </div>

        @for (question of feedbackQuestions; track $index) {

        @if ($index > 0 && question.group != feedbackQuestions[$index-1].group) {
        <div class="divider-line1 border-b-tone-05 mb-12 md:mb-[72px]"></div>
        }


        @if (question.followup == null) {
        <div class="flex flex-col gap-4 mb-12 md:mb-[72px]">
          <p class="text-black font-semibold">{{t('user.question.'+
            question.code)}}</p>
          @if (question.type === QuestionType.Emoji) {
          <div class="face-rating-wrapper justify-center">
            <input type="radio" [id]="question.code+'-5'" [formControlName]="question.code ?? ''" value="5">
            <label [for]="question.code+'-5'">😄</label>
            <input type="radio" [id]="question.code+'-4'" [formControlName]="question.code ?? ''" value="4">
            <label [for]="question.code+'-4'">🙂</label>
            <input type="radio" [id]="question.code+'-3'" [formControlName]="question.code ?? ''" value="3">
            <label [for]="question.code+'-3'">😐</label>
            <input type="radio" [id]="question.code+'-2'" [formControlName]="question.code ?? ''" value="2">
            <label [for]="question.code+'-2'">😕</label>
            <input type="radio" [id]="question.code+'-1'" [formControlName]="question.code ?? ''" value="1">
            <label [for]="question.code+'-1'">☹️</label>
          </div>
          } @else if (question.type === QuestionType.Star) {
          <div class="star-review-wrapper justify-center">
            <input type="radio" [id]="question.code+'-5'" [formControlName]="question.code ?? ''" value="5">
            <label [for]="question.code+'-5'"></label>
            <input type="radio" [id]="question.code+'-4'" [formControlName]="question.code ?? ''" value="4">
            <label [for]="question.code+'-4'"></label>
            <input type="radio" [id]="question.code+'-3'" [formControlName]="question.code ?? ''" value="3">
            <label [for]="question.code+'-3'"></label>
            <input type="radio" [id]="question.code+'-2'" [formControlName]="question.code ?? ''" value="2">
            <label [for]="question.code+'-2'"></label>
            <input type="radio" [id]="question.code+'-1'" [formControlName]="question.code ?? ''" value="1">
            <label [for]="question.code+'-1'"></label>
          </div>

          }
        </div>
        } @else if (question.followup != null && userForm.get(question.followup)?.value != null
        && userForm.get(question.followup)?.value <= '2') { @if (question.type===QuestionType.Select) { <div
          class="flex flex-col gap-4 mb-12 md:mb-[72px]">
          <p class="text-black font-semibold">{{t('user.question.'+
            question.code)}}</p>
          <div class="flex flex-col gap-2 text-sm md:w-[370px] self-center">
            @for (option of question.options; track $index) {
            <label class="visual-checkbox flex flex-col flex-1">
              <input type="radio" (click)="onSelectOption(option, question.code)" class="opacity-0 absolute h-0 w-0" [id]="question.code+'-'+$index+1"
                [value]="option" [checked]="userForm.get(question.code ?? '')?.value === option">
              <span>{{t('user.answer.'+question.code+'.'+option)}}</span>
            </label>
            }
          </div>
      </div>
      }

      }

      }
    </div>
    <button type="submit" class="btn-primary" (click)="onSubmit()">{{t('button.submit')}}</button>
  </div>
  
  </div>
  }
  @else {
  <div class="flex flex-col md:flex-row md:mt-24 gap-12">
    <div class="flex flex-col flex-1 p-4 mb-6 mb:mb-0 md:p-0 md:pl-[72px] md:items-start">
      <div class="flex flex-col">
        <h1 class="text-[40px] text-black font-semibold">{{feedbackCompleted ? t('completed.header') : t('unavailable.header')}}
        </h1>
        <p class="text-[26px] text-gray-900">{{feedbackCompleted ? t('completed.subheader') :
          t('unavailable.subheader')}}</p>
      </div>
      <button *ngIf="feedbackCompleted" [localizedRouterLink]="['/properties/' + propertyCode]" type="button"
        class="min-w-[300px] btn-primary mt-10 md:mt-[104px]">{{t('completed.button.viewProperty')}}</button>
    </div>
    <div class="flex-1 md:min-w-[410px] xl:min-w-[568px]">
      <img class="justify-self-end" src="../../../assets/img/feedback-completed.png" alt="">
    </div>
  </div>
  }
</ng-container>
}